import React, { useState, ReactNode, createContext, useContext } from "react";

interface DropdownMenuProps {
  children: ReactNode;
}

interface DropdownMenuTriggerProps {
  children: ReactNode;
}

interface DropdownMenuContentProps {
  children: ReactNode;
}

interface DropdownMenuLabelProps {
  children: ReactNode;
}

interface DropdownMenuItemProps {
  children: ReactNode;
  onSelect?: () => void;
}

interface DropdownMenuSeparatorProps {}

const DropdownContext = createContext<{ isOpen: boolean; toggle: () => void }>({
  isOpen: false,
  toggle: () => {},
});

const DropdownMenu: React.FC<DropdownMenuProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <DropdownContext.Provider value={{ isOpen, toggle }}>
      <div className="relative z-40  inline-block text-left">{children}</div>
    </DropdownContext.Provider>
  );
};

const DropdownMenuTrigger: React.FC<DropdownMenuTriggerProps> = ({
  children,
}) => {
  const { isOpen, toggle } = useContext(DropdownContext);
  // console.log(isOpen);
  return (
    <div
      onClick={toggle}
      className={`inline-flex cursor-pointer justify-center w-full text-sm font-medium rounded-full focus:outline-none p-1 ${
        isOpen ? "bg-[#17457D0F]" : "bg-white"
      }`}
    >
      {children}
    </div>
  );
};

const DropdownMenuContent: React.FC<DropdownMenuContentProps> = ({
  children,
}) => {
  const { isOpen, toggle } = useContext(DropdownContext);

  if (!isOpen) return null;

  return (
    <div
      onMouseLeave={toggle}
      className="absolute min-w-[240px] z-30 mt-2 bg-white border border-gray-300 right-0 rounded-lg drop-shadow-lg w-full"
    >
      <ul className="text-sm text-gray-700">{children}</ul>
    </div>
  );
};

const DropdownMenuLabel: React.FC<DropdownMenuLabelProps> = ({ children }) => {
  return (
    <li className="px-4 py-2 text-xs font-semibold text-gray-500">
      {children}
    </li>
  );
};

const DropdownMenuItem: React.FC<DropdownMenuItemProps> = ({
  children,
  onSelect,
}) => {
  return (
    <li
      onClick={() => {
        if (onSelect) onSelect();
      }}
      className="block px-4 py-2.5 hover:bg-gray-100 cursor-pointer first:rounded-t-lg last:rounded-b-lg"
    >
      {children}
    </li>
  );
};

const DropdownMenuSeparator: React.FC<DropdownMenuSeparatorProps> = () => {
  return <hr className="border-[#F2F4F7]" />;
};

export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
};
